import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';

import { SERIES_COLORS } from './constants';
import { CustomDateTick } from './CustomDateTick';
import { CHART_GRID_COLOR, CHART_TICK_MUTED_COLOR } from '../consts';
import { resolveMetricLabel, formatCompact, chartLegendFormatter } from '../../../../helpers';
import { ChartTooltip } from '../TooltipComponent';

interface BarSeriesChartProps {
  chartData: Array<Record<string, unknown> & { date: string }>;
  metrics: DynamicModuleMetric[];
  isStacked?: boolean;
  chartHeight?: number;
}

export const BarSeriesChart = ({ chartData, metrics, isStacked = false, chartHeight }: BarSeriesChartProps) => {
  const { t } = useTranslation('reports');

  return (
    <ResponsiveContainer
      width="100%"
      height={chartHeight || '100%'}
    >
      <BarChart
        data={chartData}
        margin={{ top: 25, right: 0, left: -20, bottom: 0 }}
        maxBarSize={30}
      >
        <CartesianGrid
          stroke={CHART_GRID_COLOR}
          vertical={false}
        />
        <XAxis
          dataKey="date"
          tick={
            <CustomDateTick
              chartData={chartData}
              bandScale
            />
          }
          axisLine={false}
          tickLine={false}
          interval="preserveStartEnd"
        />
        <YAxis
          tick={{ fontSize: 12, fill: CHART_TICK_MUTED_COLOR, textAnchor: 'end' }}
          tickCount={10}
          tickFormatter={formatCompact}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip
          cursor={false}
          content={<ChartTooltip />}
        />
        <Legend
          align="left"
          iconType="circle"
          iconSize={12}
          wrapperStyle={{
            fontSize: '12px',
            marginBottom: '3px',
            marginTop: '10px',
            marginLeft: '25px',
          }}
          formatter={chartLegendFormatter}
        />
        {metrics.map((metric, idx) => (
          <Bar
            key={metric.name}
            dataKey={metric.name}
            name={resolveMetricLabel(metric.name, t)}
            fill={SERIES_COLORS[idx % SERIES_COLORS.length]}
            stackId={isStacked ? 'stack' : undefined}
            isAnimationActive={false}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
